module.exports = __webpack_public_path__ + "img/background2.7e81514a.jpg";